import styled from 'styled-components';
import Card from '$app/components/vendor/Card';
import { Alert, Input } from 'antd';
import Table from '../../../components/Table';
import ActionButton from '../../../components/ActionButton';
import P from '../../../components/P';
import Modal from '../../../components/Modal';

const colors = {
  'title-black': '#201e1e',
  'clear-blue': '#2b9bff',
};

export const dropdownStyling = {
  padding: '10px',
  lineHeight: '20px',
  marginTop: '-10px',
  marignLeft: '-10px',
};

export const expandableBtnStyle = {
  fontWeight: 'bold',
  textAlign: 'center',
  cursor: 'pointer',
};

export const GarageSearch = styled(Input)`
  width: 316px;
  position: relative;
  padding: 4px 8px;
  height: auto;
  text-align: center;
  float: right;
  margin-right: 40px;
  border-color: #a6a6a6;
  color: #a6a6a6;
`;

export const StyledModal = styled(Modal)`
  .ant-modal-title {
    display: block;
    font-size: 17px;
    line-height: 30px;
  }
  .ant-modal-body {
    padding: 0 !important;
  }
`;

export const StyledInvitationCancellationModal = styled(Modal)`
  p {
    font-weight: bold;
    display: block;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  i.text-red {
    color: #c20808;
    font-weight: normal;
    font-size: 13px;
  }
`;

export const GarageAllocationCard = styled(Card)`
  .view-hover {
    cursor: pointer;
    color: #2b9bff;
    display: block;
    text-align: center;
    i {
      top: 1px;
      position: relative;
      padding-right: 5px;
    }
  }
  .ant-tag {
    width: 100px;
    text-align: center;
    text-wrap: balance;
    line-height: 12px;
    padding: 4px 8px 4px 8px;
    font-weight: 550;
    size: 10px;
    font-family: Verdana;
    border: 0;

    &::first-letter {
      text-transform: capitalize;
    }

    &.draft {
      background: #6d7287;
      color: white;
    }
    &.pending {
      background: #fff4d8;
      color: #2c3750;
    }
    &.review {
      background: #fff2f3;
      color: #da1e28;
    }
  }
  .hidden-invites-toggle {
    text-align: center !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    padding: 16px 0px;
    border-top: 1px solid #d6d5e3;
    color: #1b2640;
    margin: 0 -17px;
    margin-top: 5px;
    cursor: pointer;
  }
  .menu {
    text-align: center;
    padding: 0;
    a {
      display: block;
      padding: 16px;
    }
    i {
      color: #949494;
    }
  }
  table {
    border-collapse: collapse;
    th td {
      background: #d6d5e3;
    }
    td:first-of-type {
      padding-left: 45px;
      font-weight: 600;
    }
  }
  .ant-table-thead tr:first-of-type th {
    background: white;
    border-top: 1px solid #d6d5e3;
    border-bottom: 1px solid #d6d5e3;
    text-align: left !important;
  }
  tr td:nth-of-type(4),
  tr th:nth-of-type(4),
  tr td:nth-of-type(10),
  tr th:nth-of-type(10) {
    border-right: 1px solid #d6d5e3;
  }
`;

export const TitleDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  h3 {
    margin-bottom: 0 !important;
  }
`;

export const GarageListTable = styled(Table)`
  .ant-table-content {
    font-size: 12px;
    margin-bottom: 22px;
    .ant-table-row.selected {
      background: #e6f7ff;
    }
    .ant-badge-status-text span {
      font-weight: 550;
    }
  }
  .grey {
    color: #bfbfbf;
  }
  .red {
    color: rgb(255, 88, 88);
  }
  table tbody {
    display: block;
    max-height: 40vh;
    overflow-y: auto;
  }

  table thead,
  table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
`;

export const PickGarageDiv = styled.div`
  color: ${colors['clear-blue']};
  display: flex;
  margin-left: 10px;
  p {
    font-size: 13px;
    margin-bottom: 0;
    margin-left: 3px;
    padding-top: 6px;
  }
`;
export const AddAction = styled(ActionButton)`
  padding-top: 5px;
  padding-right: 15px;
  p {
    padding-top: 0;
  }
`;

export const SmallP = styled(P)`
  font-size: 13px;
  margin-bottom: 0;
  margin-left: 3px;
  padding-top: 6px;
  color: ${colors['clear-blue']};
`;

export const CancelAction = styled.button`
  border: 0;
  background: transparent;
  color: red;
  clear: both;
  margin: 0;
  padding: 5px 12px;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
  display: block;

  &:hover {
    background-color: #e6f7ff;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-top: -10px !important;
  margin-bottom: 10px !important;
`;

export const OpenLink = styled.div`
  display: inline-block;
  margin-left: auto;
  cursor: pointer;
  a {
    text-decoration: none;
  }
`;

export const BottomDiv = styled.div`
  button > span {
    text-decoration: underline;
  }
  .ant-radio-group {
    margin-left: 16px;
  }
  .load-more {
    display: block;
    width: 100%;
    border: 1px solid #e8e8e8;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    padding: 25px;
    height: auto;
    text-transform: uppercase;
    color: #3b80e3;
    font-weight: bold;
    span {
      text-decoration: none;
    }
  }
`;
